export default {
    username:'اسم المستخدم',
    name:'اسم',
    lastname:'اسم العائلة',
    status:'الحالة',
    actions:'أجراءاتا',
    image:'صورة',
    addNewDoctor:'إضافة طبيب جديد ',
    of:'من'
}